// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__t4Ac0"};